import { ReactNode } from 'react';
import { areasImagesMap, Major, RecommendationChipData } from '@common-types';

import { MAX_CHIPS_WITH_LABEL, RECOMMENDATION_CHIPS_DATA } from '@constants/major';
import { COLLEGES_IMAGES_URL, MAJORS_IMAGES_URL } from '@constants/externalRoutes';
import { areasIconsMap } from '@constants/areasOfStudy';

export const renderPersonalRecommendationChips = (
  majorData: Partial<Major>,
  renderItem: (chipData: RecommendationChipData, isRenderText: boolean) => ReactNode,
) => {
  return RECOMMENDATION_CHIPS_DATA.filter((item) => (majorData as Record<string, Array<unknown>>)[item.type]).map(
    (item, index, array) => {
      return renderItem(item, array.length <= MAX_CHIPS_WITH_LABEL);
    },
  );
};

export const getMajorIconSrc = (areaCipCode: number) => {
  const areaIconSrc = `${MAJORS_IMAGES_URL}/majors/${areasIconsMap.get(areaCipCode.toString())}`;
  return areaIconSrc;
};

export const getMajorImageSrc = (areaCipCode: number) => {
  const areaImageSrc = `${COLLEGES_IMAGES_URL}/${areasImagesMap.get(areaCipCode.toString())}`;
  return areaImageSrc;
};
